export const LOGOUT_BROADCAST_KEY = 'keru_logout_broadcast';

export function broadcastLogout() {

    try {

        localStorage.setItem(LOGOUT_BROADCAST_KEY, String(Date.now()));

    } catch (error) {

        console.error('Logout broadcast error:', error);

    }
}
